<template>
  <div>
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <div style="float: right;padding-bottom: 20px">
            <el-button icon="el-icon-plus" type="primary" @click="editRow(null)">添加轮播</el-button>
          </div>
          <div v-loading="loading" class="card-content">
            <el-table
              :data="tableData"
              stripe
              style="width: 100%;margin-bottom: 20px">
              <el-table-column
                label="轮播图"
                align="center"
                width="200"
              >
                <template slot-scope="scope">
                  <el-image
                    :src="scope.row.imgurl"
                    fit="cover"
                    style="height: 40px;"
                    :preview-src-list="[scope.row.imgurl]"
                  />
                </template>
              </el-table-column>
              <el-table-column
                label="优先级"
                min-width="200"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.xuhao }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="200"
                align="center"
                fixed="right"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button icon="el-icon-edit" size="mini" @click="editRow(scope.row)">修改</el-button>
                  <el-button icon="el-icon-delete" size="mini" @click="deleteRow(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="total>0"
              background
              :current-page="currentPage"
              :page-sizes="[20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editTitle"
      :visible.sync="dialogVisible"
      width="600px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="editForm" size="small" :model="editForm" label-width="80px" :rules="dilogrules" style="padding:15px 30px 15px 15px;">
        <el-form-item label="优先级" prop="xuhao">
          <el-input-number v-model="editForm.xuhao" :min="0" :max="999" ></el-input-number>
          <span style="color:#99a9bf;font-size:12px;margin-left: 10px">越小越优先</span>
        </el-form-item>
        <el-form-item label="轮播图" prop="img">
          <span style="color:#99a9bf;"><i class="el-icon-warning"></i> 建议上传375*812尺寸的图片</span>
          <SingleImg :key="imgkey" v-model="editForm.img" :oldurl="editForm.oldimgurl" :size="[375,812]" />
        </el-form-item>
        <el-form-item>
          <el-button :loading="eidtLoading" type="primary" @click="SubForm()">立即提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>

import SingleImg from '@/components/upload/SingleImg'
import { getUser } from '@/utils/auth'
import { delAppletHomeBanner, editAppletHomeBanner, getAppletHomeBannerList } from '@/api/sxjxcx'

export default {
  name: 'sydtgl',
  components: {
    SingleImg
  },
  data() {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      editTitle: '',
      dialogVisible: false,
      editForm: {
        xuhao: '',
        img: null,
        oldimgurl: '',
        bannerid: ''
      },
      imgkey: '',
      eidtLoading: false
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      const data = {
        page: this.currentPage,
        limit: this.pageSize
      }
      getAppletHomeBannerList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    editRow(row) {
      if (row === null) {
        this.editTitle = '添加轮播'
        this.editForm.bannerid = 0
        this.editForm.xuhao = ''
        this.editForm.img = null
        this.editForm.oldimgurl = ''
      } else {
        this.editTitle = '编辑轮播'
        this.editForm.bannerid = row.bannerid
        this.editForm.xuhao = row.xuhao
        this.editForm.img = { imgid: row.imgid, imgurl: row.imgurl }
        this.editForm.oldimgurl = row.imgurl
      }
      this.imgkey = (new Date().getTime() + 33).toString()
      this.dialogVisible = true
    },
    SubForm() {
      if (!this.eidtLoading) {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.eidtLoading = true
            const data = {
              abc: 0, // 屏蔽网页拦截
              bannerid: this.editForm.bannerid,
              imgid: this.editForm.img.imgid,
              xuhao: this.editForm.xuhao
            }
            editAppletHomeBanner(data).then(response => {
              this.eidtLoading = false
              this.$message({
                type: 'success',
                message: '提交成功'
              })
              this.getData()
              this.dialogVisible = false
            }).cache(() => {
              this.eidtLoading = false
            })
          }
        })
      }
    },
    deleteRow(row) {
      this.$confirm('您确定要删除此图片吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        delAppletHomeBanner({ abc: 0, bannerid: row.bannerid }).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.getData()
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>

</style>
<!--
<template>
  <div>
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small">
            <el-form-item style="float: right">
              <el-button icon="el-icon-plus" type="primary" @click="editRow(null)">添加轮播</el-button>
            </el-form-item>
          </el-form>
          <div v-loading="loading" class="card-content">
            <el-table
              :data="tableData"
              stripe
              style="width: 100%;margin-bottom: 20px"
            >
              <el-table-column
                label="轮播图"
                align="center"
                width="200"
              >
                <template slot-scope="scope">
                  <el-image
                    :src="scope.row.imgurl"
                    fit="cover"
                    style="height: 40px;"
                    :preview-src-list="[scope.row.imgurl]"
                  />
                </template>
              </el-table-column>
              <el-table-column
                label="优先级"
                min-width="200"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.xuhao }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="200"
                align="center"
                fixed="right"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button icon="el-icon-edit" size="mini" @click="editRow(scope.row)">修改</el-button>
                  <el-button icon="el-icon-delete" size="mini" @click="deleteRow(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="total>0"
              background
              :current-page="currentPage"
              :page-sizes="[20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editTitle"
      :visible.sync="dialogVisible"
      width="600px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="editForm" size="small" :model="editForm" label-width="80px" :rules="dilogrules" style="padding:15px 30px 15px 15px;">
        <el-form-item label="优先级" prop="xuhao">
          <el-input-number v-model="editForm.xuhao" :min="0" :max="999" ></el-input-number>
          <span style="color:#99a9bf;font-size:12px;margin-left: 10px">越小越优先</span>
        </el-form-item>
        <el-form-item label="轮播图" prop="img">
          <span style="color:#99a9bf;"><i class="el-icon-warning"></i> 建议上传375*812尺寸的图片</span>
          <SingleImg :key="imgkey" v-model="editForm.img" :oldurl="editForm.oldimgurl" :size="[375,812]" />
        </el-form-item>
        <el-form-item>
          <el-button :loading="eidtLoading" type="primary" @click="SubForm()">立即提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import SingleImg from '@/components/upload/SingleImg'
import { delDelShopBanner } from '@/api/dealer'
import { editAppletHomeBanner, getAppletHomeBannerList } from '@/api/sxjxcx'

export default {
  name: 'sydtgl',
  components: {
    SingleImg
  },
  data() {
    return {
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      dilogrules: {
        xuhao: [{ required: true, message: '请输入优先级', trigger: 'blur' }],
        img: [{ required: true, message: '请上传轮播图片', trigger: 'change' }]
      },
      editForm: {
        xuhao: '',
        img: null,
        oldimgurl: '',
        bannerid: 0
      },
      editTitle: '',
      dialogVisible: false,
      eidtLoading: false,
      imgkey: ''
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      const data = {
        page: this.currentPage,
        limit: this.pageSize
      }
      getAppletHomeBannerList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    editRow(row) {
      if (row === null) {
        this.editTitle = '添加轮播'
        this.editForm.bannerid = 0
        this.editForm.xuhao = ''
        this.editForm.img = null
        this.editForm.oldimgurl = ''
      } else {
        this.editTitle = '编辑轮播'
        this.editForm.bannerid = row.bannerid
        this.editForm.xuhao = row.xuhao
        this.editForm.img = { imgid: row.imgid, imgurl: row.imgurl }
        this.editForm.oldimgurl = row.imgurl
      }
      this.imgkey = (new Date().getTime() + 33).toString()
      this.dialogVisible = true
    },
    SubForm() {
      if (!this.eidtLoading) {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.eidtLoading = true
            const data = {
              bannerid: this.editForm.bannerid,
              imgid: this.editForm.img.imgid,
              xuhao: this.editForm.xuhao
            }
            editAppletHomeBanner(data).then(response => {
              this.eidtLoading = false
              this.$message({
                type: 'success',
                message: '提交成功'
              })
              this.dialogVisible = false
            }).catch(() => {
              this.eidtLoading = false
            })
          }
        })
      }
    },
    deleteRow(row) {
      this.$confirm('您确定要删除此轮播吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        delDelShopBanner({ dsbid: row.dsbid }).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.getData()
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>

</style>
-->
